import React from 'react';
import { StarIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-217" data-mp="3fznszj43v70b">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-218" data-mp="3fy2yfthsjo2g">
        <div className="max-w-2xl" data-id="element-219" data-mp="3b1471ipihv7y">
          <h2 className="font-display text-3xl font-black tracking-tight text-forest sm:text-4xl lg:text-5xl" data-id="element-220" data-mp="3azt0jb4om9d5">
            {t.testimonials.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-neutral-600" data-id="element-221" data-mp="31zd2ih6pjufo">
            {t.testimonials.intro}
          </p>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-222" data-mp="2x1l02t8fspx8">
          {t.testimonials.items.map(item => <li key={item.name} className="flex h-full flex-col rounded-lg border border-neutral-200 bg-white p-7" data-id="element-223" data-mp="2s39reltvolgl">
              <div className="flex gap-1" aria-label={t.testimonials.ratingAria} data-id="element-224" data-mp="q9tzzmpyv2kk">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-rust text-rust" aria-hidden="true" data-id="element-225" data-mp="h4dfoti1e27v" data-mpi={i} />)}
              </div>
              <blockquote className="mt-5 text-[15px] leading-relaxed text-neutral-700" data-id="element-226" data-mp="79v7bb1odihq">
                “{item.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-7" data-id="element-227" data-mp="zw65kf1t77bd">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-forest font-display text-sm font-bold text-white" data-id="element-228" data-mp="14vj3buu7xysq">
                  {item.name.charAt(0)}
                </span>
                <span data-id="element-229" data-mp="v5ppen6lt7lb">
                  <span className="block font-display text-sm font-bold text-forest" data-id="element-230" data-mp="v4xwxl8azpz9">
                    {item.name}
                  </span>
                  <span className="block text-xs text-neutral-500" data-id="element-231" data-mp="1itz9nko65nac">
                    {item.location}
                  </span>
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}